import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e1947f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-lg-4 px-3 pt-5 pb-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3 col-md-4 col-6 mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Quick Links", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-4 col-6 mb-3" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("h4", null, "Contact Us"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Ministry of Health, Botswana"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Nelson Mandela Dr, Gaborone, Botswana"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("a", { href: "tel:+2673632500" }, "+267 363 2500")
    ])
  ])
], -1))
const _hoisted_6 = { class: "col-lg-3 col-md-4 col-12 mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Newsletter", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Subscribe to our newsletter to get more updates.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 input" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "newsletter",
    class: "d-none"
  }, "NewsLetter"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "email",
    placeholder: "Email",
    class: "form-control border-0",
    id: "newsletter",
    name: "newsletter",
    autocomplete: "email"
  })
], -1))
const _hoisted_10 = { class: "col-lg-3 col-12 mb-3 text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "social media", -1))
const _hoisted_12 = { class: "social-icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon bi-instagram" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon bi-facebook" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon bi-twitter" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon bi-youtube" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("Home ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/faq" }, {
                default: _withCtx(() => [
                  _createTextVNode("FAQs")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/resource-library" }, {
                default: _withCtx(() => [
                  _createTextVNode("Resource Library")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_BaseButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newsLetter())),
              customStyle: _ctx.buttonStyle
            }, {
              default: _withCtx(() => [
                _createTextVNode("subscribe")
              ]),
              _: 1
            }, 8, ["customStyle"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}